import { RefObject, useEffect, useRef } from "react";

import { recordFaceEmotions } from "../services/faceEmotionAccumulator";
import { captureVideoFrameBase64, detectFaces } from "../services/googleCloudApi";

const CAPTURE_INTERVAL_MS = 5000;

export function useFacialAnalysis(
  videoRef: RefObject<HTMLVideoElement | null>,
  enabled: boolean
): void {
  const isRunningRef = useRef(false);

  useEffect(() => {
    if (!enabled) return;

    const runCapture = async () => {
      if (isRunningRef.current) return;
      const video = videoRef.current;
      if (!video || video.readyState < HTMLMediaElement.HAVE_CURRENT_DATA) return;

      isRunningRef.current = true;
      try {
        const base64 = captureVideoFrameBase64(video);
        if (!base64) return;

        const result = await detectFaces(base64);
        if (result.emotions) {
          recordFaceEmotions(result.emotions);
        }
        console.info(
          `[Intake] Vision: ${result.facesDetected} face(s) detected`,
          result.emotions ?? result.annotations
        );
      } finally {
        isRunningRef.current = false;
      }
    };

    void runCapture();
    const intervalId = window.setInterval(() => {
      void runCapture();
    }, CAPTURE_INTERVAL_MS);

    return () => window.clearInterval(intervalId);
  }, [enabled, videoRef]);
}
